import styled from '@emotion/styled'
import { memo } from 'react'
import {
    AppStateType,
    useAppState,
    useAppStateSelector,
} from '../../Hooks/useAppState'
import { palette } from '../../styles/colors'
import Login from './Login'
import SignUp from './SignUp'

export const AuthRoot = styled('div')({
    display: 'flex',
    height: '100%',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    background: palette.background,
})

type AuthenticationProps = {
    subject?: string
    redirect?: string
    signup?: boolean
}

const Authentication = memo((props: AuthenticationProps) => {
    const isAuthenticated = useAppStateSelector(
        AppStateType.APP,
        'authenticated',
    )
    const authState = useAppState(AppStateType.AUTHENTICATION)
    const { success, verified } = authState
    const { subject, signup, redirect } = props

    if (signup && (!isAuthenticated || success || verified)) {
        return <SignUp />
    }

    return <Login subject={subject} redirect={redirect} />
})

export default Authentication
